import { useState, useEffect } from "react";

const useDebounce = <T extends string>(
  value: T,
  delay: number,
  length: number = 2
): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  useEffect(() => {
    if (value.length >= length) {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
